import { render, staticRenderFns } from "./Step-4.vue?vue&type=template&id=6d6d6f9e&scoped=true&"
import script from "./Step-4.vue?vue&type=script&lang=js&"
export * from "./Step-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6d6f9e",
  null
  
)

export default component.exports